import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTickIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 14,
	height: 13,
	viewBox: "0 0 14 13",
	fill: "#fff",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		id: "Path_6877",
		"data-name": "Path 6877",
		d: "M8.546,16.235,5.628,12.767a1,1,0,0,0-1.424,0,1.016,1.016,0,0,0,0,1.437l3.62,4.176a1.007,1.007,0,0,0,1.434,0l8.35-10.962a1.016,1.016,0,0,0,0-1.437,1,1,0,0,0-1.424,0Z",
		transform: "translate(-3.906 -5.681)"
	})
});
export { SvgTickIcon as ReactComponent };
